import $ from 'jquery'

function TableTooltip () {}

TableTooltip.prototype.init = function ( tooltipId )
{
    this._tooltipEl = $( "#" + tooltipId );
    this._tooltipTextPlaceholder = this._tooltipEl.find( "#" + tooltipId + "_textPlaceholder" );

    return this;
};

TableTooltip.prototype.updateUI = function ( config )
{
    // abstract
};

TableTooltip.prototype.updateUIAndShow = function ( config, offset)
{
    this.updateUI( config );
    this.show();

    if( offset )
        this.move( offset );
};

TableTooltip.prototype.move = function ( offset )
{
    this._tooltipEl.offset( offset );
};

TableTooltip.prototype.show = function ()
{
    this._tooltipEl.show();
};

TableTooltip.prototype.hide = function ()
{
    this._tooltipEl.hide();
};

TableTooltip.prototype.getHeight = function ()
{
    return this._tooltipEl.outerHeight();
};

TableTooltip.prototype.getWidth = function ()
{
    return this._tooltipEl.outerWidth();
};

TableTooltip.prototype.setHtml = function(html) {
    this._tooltipTextPlaceholder.html(html)
}

export default TableTooltip



// WEBPACK FOOTER //
// ./web/js/controls/TableTooltip.js